"use strict";
/**
 * Document API Request Contracts (GH#21)
 *
 * Shapes the frontend (and migration script) sends to the backend.
 * Per `api-contracts.md`:
 *   - Date fields are ISO 8601 strings, never `Date` objects.
 *   - Update requests are partial; Create requests are complete.
 */
Object.defineProperty(exports, "__esModule", { value: true });
